/* unplugin-vue-components disabled */import script from "./404.vue?vue&type=script&setup=true&lang=ts"
export * from "./404.vue?vue&type=script&setup=true&lang=ts"

import "./404.vue?vue&type=style&index=0&id=1d929f9c&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1d929f9c"]])

export default __exports__